/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ManagementRole } from './ManagementRole';
import {
    ManagementRoleFromJSON,
    ManagementRoleFromJSONTyped,
    ManagementRoleToJSON,
    ManagementRoleToJSONTyped,
} from './ManagementRole';
import type { FleetRole } from './FleetRole';
import {
    FleetRoleFromJSON,
    FleetRoleFromJSONTyped,
    FleetRoleToJSON,
    FleetRoleToJSONTyped,
} from './FleetRole';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
    LengthUnitToJSONTyped,
} from './LengthUnit';

/**
 * Remember to update [`ExportUser`](crate::schemas::background_jobs_export_user::ExportUser) when adding new fields to this struct.  This is required to ensure GDPR compliance!
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    employeeId: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string | null;
    /**
     * 
     * @type {ManagementRole}
     * @memberof User
     */
    managementRole?: ManagementRole | null;
    /**
     * 
     * @type {FleetRole}
     * @memberof User
     */
    fleetRole?: FleetRole | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    departmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    shiftId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    siteId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    licenseExpiryDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    expiryLogout: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    nfcToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    nfcTokenDescription?: string | null;
    /**
     * This value is refreshed whenever the fleet authenticate period table updates. We maintain multiple database triggers for this: - `add_login_time` - `update_login_time` - `remove_login_time`
     * @type {number}
     * @memberof User
     */
    totalLoginSeconds: number;
    /**
     * This value is refreshed whenever the vehicle movement period table updates. We maintain multiple database triggers for this: - `add_drive_time` - `update_drive_time` - `remove_drive_time`
     * @type {number}
     * @memberof User
     */
    totalDriveSeconds: number;
    /**
     * 
     * @type {LengthUnit}
     * @memberof User
     */
    lengthUnit?: LengthUnit | null;
}



/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('expiryLogout' in value) || value['expiryLogout'] === undefined) return false;
    if (!('totalLoginSeconds' in value) || value['totalLoginSeconds'] === undefined) return false;
    if (!('totalDriveSeconds' in value) || value['totalDriveSeconds'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'employeeId': json['employeeId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'managementRole': json['managementRole'] == null ? undefined : ManagementRoleFromJSON(json['managementRole']),
        'fleetRole': json['fleetRole'] == null ? undefined : FleetRoleFromJSON(json['fleetRole']),
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'departmentId': json['departmentId'] == null ? undefined : json['departmentId'],
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'licenseExpiryDate': json['licenseExpiryDate'] == null ? undefined : (new Date(json['licenseExpiryDate'])),
        'expiryLogout': json['expiryLogout'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'nfcToken': json['nfcToken'] == null ? undefined : json['nfcToken'],
        'nfcTokenDescription': json['nfcTokenDescription'] == null ? undefined : json['nfcTokenDescription'],
        'totalLoginSeconds': json['totalLoginSeconds'],
        'totalDriveSeconds': json['totalDriveSeconds'],
        'lengthUnit': json['lengthUnit'] == null ? undefined : LengthUnitFromJSON(json['lengthUnit']),
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'employeeId': value['employeeId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'managementRole': ManagementRoleToJSON(value['managementRole']),
        'fleetRole': FleetRoleToJSON(value['fleetRole']),
        'jobTitle': value['jobTitle'],
        'departmentId': value['departmentId'],
        'shiftId': value['shiftId'],
        'siteId': value['siteId'],
        'licenseExpiryDate': value['licenseExpiryDate'] == null ? value['licenseExpiryDate'] : value['licenseExpiryDate'].toISOString(),
        'expiryLogout': value['expiryLogout'],
        'imageId': value['imageId'],
        'nfcToken': value['nfcToken'],
        'nfcTokenDescription': value['nfcTokenDescription'],
        'totalLoginSeconds': value['totalLoginSeconds'],
        'totalDriveSeconds': value['totalDriveSeconds'],
        'lengthUnit': LengthUnitToJSON(value['lengthUnit']),
    };
}

